import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

export const CircularProgressLoadingPage = () => {
  return (
    <Box sx={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress size={80} />
    </Box>
  );
};
